import * as FuncionesServices from "../../utils/funciones-services";

export const getAdn = async (idProspecto) => {
    let atributos = [{ campo: 'idProspecto', valor: idProspecto }]
    return FuncionesServices.procesarRespuesta({
        url: FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_ADN, atributos),
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'Iam-id-token'              : 'Bearer ' + FuncionesServices.getIamToken(),
            'transactionId'             : FuncionesServices.generarCorrelativo(),
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'businessProcess'           : process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName'           : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'           : 'test'
        })
    })
}